// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultButton_wrapper__REJ9N","selected":"DefaultButton_selected__2VYEy"};